import React, { useState, useEffect } from "react";
import Navbar from "src/components/Navbar";
import Footer from "src/components/Footer";
import { checkoutimg } from "src/assets/images";
import { useMutation } from "@tanstack/react-query";
import { renderErrorMessage, renderSuccessMessage } from "src/assets/functions";
import { useNavigate } from 'react-router-dom';
import { CreateOrder } from "src/api";
import { Formik } from "formik";
import { useProtectedRoutesContext } from "src/context/ProtectedRoutes";

const Checkout = () => {
    const { unitId } = useProtectedRoutesContext()
    const [cartItems, setCartItems] = useState([]);
    let storedObject = localStorage.getItem('user');
    const { conversionRates } = useProtectedRoutesContext()


    useEffect(() => {
        const storedCart = localStorage.getItem("cart");
        if (storedCart) {
            setCartItems(JSON.parse(storedCart));
        }
    }, []);

    const { mutate, isLoading } = useMutation(CreateOrder, {
        onSuccess: (data) => {
            renderSuccessMessage(data.message);
            localStorage.removeItem("cart");
            // navigate(`${data?.link}`);
            window.location.href = data?.link; // Redirects to external link
        },
        onError: (error) => renderErrorMessage(error.message),
    });

    let phoneNumber = "";
    if (storedObject) {
        let parsedObject = JSON.parse(storedObject);
        phoneNumber = parsedObject?.phoneNumber;
    }

    const initialValues = {
        email: "",
        phoneNumber: phoneNumber,
        city: "",
        address: "",
    };

    return (
        <>
            <Navbar />
            <div className="container mx-auto py-10 px-4 lg:px-0">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
                    {/* Left Section - Checkout Details */}
                    <div className="lg:col-span-8 bg-white p-6">
                        <h2 className="text-2xl font-semibold mb-4">Checkout Details</h2>
                        <Formik
                            initialValues={initialValues}
                            onSubmit={(values) => {
                                const formattedItems = cartItems.map((item) => ({
                                    itemId: item.id, // Assuming id is itemId
                                    quantity: item.quantity,
                                    unitId,
                                }));

                                const orderData = {
                                    ...values,
                                    discount: 10, // Set discount if applicable
                                    staffId: 1, // Assuming static staff ID
                                    items: formattedItems,
                                };

                                mutate(orderData);
                            }}
                        >
                            {({ values, handleChange, handleBlur, handleSubmit }) => (
                                <form className="space-y-4" onSubmit={handleSubmit}>
                                    <input
                                        type="email"
                                        name="email"
                                        placeholder="Email Address"
                                        className="w-full p-3 border rounded-md"
                                        value={values.email}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        required
                                    />
                                    <select
                                        name="city"
                                        className="w-full p-3 border rounded-md fatix-input-patterns"
                                        value={values.city}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="" disabled>
                                            Select City
                                        </option>
                                        {[
                                            "Abia", "Adamawa", "Akwa Ibom", "Anambra", "Bauchi", "Bayelsa", "Benue", "Borno",
                                            "Cross River", "Delta", "Ebonyi", "Edo", "Ekiti", "Enugu", "Gombe", "Imo",
                                            "Jigawa", "Kaduna", "Kano", "Katsina", "Kebbi", "Kogi", "Kwara", "Lagos",
                                            "Nasarawa", "Niger", "Ogun", "Ondo", "Osun", "Oyo", "Plateau", "Rivers",
                                            "Sokoto", "Taraba", "Yobe", "Zamfara",
                                        ].map((state) => (
                                            <option key={state} value={state}>
                                                {state}
                                            </option>
                                        ))}
                                    </select>
                                    <input
                                        type="tel"
                                        name="phoneNumber"
                                        placeholder="Phone Number"
                                        className="w-full p-3 border rounded-md"
                                        value={values.phoneNumber}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        // required
                                        disabled
                                    />
                                    <textarea
                                        name="address"
                                        placeholder="Shipping Address"
                                        className="w-full p-3 border rounded-md h-24"
                                        value={values.address}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                    // required
                                    />
                                    <button
                                        type="submit"
                                        className="w-full bg-blue-600 text-white py-3 rounded-md"
                                        disabled={isLoading}
                                    >
                                        {isLoading ? "Processing..." : "Proceed to Payment"}
                                    </button>
                                </form>
                            )}
                        </Formik>
                    </div>

                    {/* Right Section - Order Summary */}
                    <div className="lg:col-span-4 p-6 rounded-lg">
                        <h2 className="text-xl font-semibold mb-4">Order Summary</h2>
                        {cartItems.length > 0 ? (
                            cartItems.map((item) => (
                                <div key={item.id} className="flex gap-4 border-b pb-4 mb-4">
                                    <img
                                        src={item.itemImages?.[0].url || checkoutimg}






















                                        alt="Product"
                                        className="w-[150px] h-[150px] object-cover rounded-md"
                                    />
                                    <div>
                                        <h3 className="text-lg font-medium">Design #{item.design_number}</h3>
                                        <p className="text-gray-600">₦{item.grade.price * conversionRates[item?.materialId]}</p>
                                        <p className="text-gray-500">Material: {item.material.name}</p>
                                        <p className="text-gray-500">Qty: {item.quantity}</p>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p className="text-gray-500">Your cart is empty.</p>
                        )}

                        {/* Pricing Details */}
                        <div className="space-y-2">
                            <div className="flex justify-between">
                                <span className="text-gray-600">Subtotal</span>
                                <span className="text-gray-900 font-semibold">
                                    ₦
                                    {cartItems
                                        .reduce((sum, item) => sum + item.grade.price * item.quantity * conversionRates[item?.materialId], 0)
                                        .toLocaleString()}
                                </span>
                            </div>
                            <div className="flex justify-between border-t pt-2">
                                <span className="text-gray-600">TOTAL</span>
                                <span className="text-lg font-bold text-gray-900">
                                    ₦
                                    {cartItems
                                        .reduce((sum, item) => sum + item.grade.price * item.quantity * conversionRates[item?.materialId], 0)
                                        .toLocaleString()}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default Checkout;
